import { addReview as Constants } from "../constants";
import { reviewApi as api } from "../../api";

export const reviewsApi = {
  _addReview,
  _getReviews,
};

function _addReview(payload) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._add_review(payload).then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.ADD_REVIEW_SUCCESS, payload };
  }
  function failure(error) {
    return { type: Constants.ADD_REVIEW_FAILED, error };
  }
}

function _getReviews(payload) {
    return (dispatch) => {
      return new Promise((resolve, reject) => {
        api._get_reviews(payload).then(
          (payload) => {
            dispatch(success(payload));
            resolve(payload);
          },
          (error) => {
            dispatch(failure("Failed"));
            reject(error);
          }
        );
      });
    };
    function success(payload) {
      return { type: Constants.ADD_REVIEW_SUCCESS, payload };
    }
    function failure(error) {
      return { type: Constants.ADD_REVIEW_FAILED, error };
    }
  }
